import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { Countdown } from './Countdown';
import { SectionHeading } from './SectionHeading';
const benefits = ['6 tomos digitales + 6 bonos', 'Acceso inmediato y de por vida', 'Garantía total de 7 días', 'Guiones y protocolos listos para usar'];
export function Offers() {
  return <section id="oferta" className="bg-[#4C1D95] px-5 py-14 sm:px-8 sm:py-20" data-id="element-66" data-mp="fbt60528lok4">
      <div className="mx-auto max-w-xl" data-id="element-67" data-mp="f9q68tba8h27">
        <Countdown data-id="element-68" data-mp="kbfj8ei2f4sx" />

        <div className="mt-12" data-id="element-69" data-mp="k9ulkg0gf5qu">
          <SectionHeading centered light eyebrow="Tu acceso completo" title="La próxima sesión puede ser tuya, no del miedo." data-id="element-70" data-mp="k8tc2fz36rb8" />
        </div>

        <article className="mt-9 border border-[#D8C7F2] bg-[#FFFDFB] p-6 sm:p-8" data-id="element-71" data-mp="aesyrqtnifrf">
          <p className="text-center text-xs font-bold uppercase tracking-[.17em] text-[#6D28D9]" data-id="element-72" data-mp="2qzskunuzt33f">
            Sistema completo
          </p>
          <h3 className="mt-3 text-center font-serif text-3xl font-semibold text-[#24212A] sm:text-4xl" data-id="element-73" data-mp="2fncfb8mqti9h">
            El Oráculo del Terapeuta
          </h3>
          <p className="mx-auto mt-3 max-w-md text-center text-sm leading-6 text-[#5E5968]" data-id="element-74" data-mp="2aq2kfdgl4ee9">
            Todo lo que necesitás para dejar de improvisar cuando más importa.
          </p>

          <div className="mt-7 flex items-end justify-center gap-3" data-id="element-75" data-mp="2klw4dhwmva62">
            <span className="text-lg text-[#817A88] line-through" data-id="element-76" data-mp="2ylx60zkq2lml">$197</span>
            <strong className="font-serif text-6xl text-[#6D28D9]" data-id="element-77" data-mp="2tndemjnd0hmu">
              $12.99
            </strong>
            <span className="mb-2 text-sm text-[#5E5968]" data-id="element-78" data-mp="38c059hifsvtd">USD</span>
          </div>
          <p className="mt-1 text-center text-xs font-bold uppercase tracking-wide text-[#6D28D9]" data-id="element-79" data-mp="33d6qzmvbt0s5">
            Precio promocional de lanzamiento
          </p>

          <ul className="my-7 space-y-3 border-y border-[#E5E0EC] py-6 text-sm text-[#514B5A]" data-id="element-80" data-mp="3hdhhgosq4dcs">
            {benefits.map(benefit => <li key={benefit} className="flex gap-2" data-id="element-81" data-mp="2a0fgg1zl1yzo">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-[#6D28D9]" aria-hidden="true" data-id="element-82" data-mp="2a2091m2c77uw" />
                {benefit}
              </li>)}
          </ul>

          <CTAButton data-id="element-83" data-mp="2iz0upky0urun">Quiero mi Oráculo ahora</CTAButton>
        </article>

        <p className="mt-6 text-center text-xs text-[#EEE7FA]" data-id="element-84" data-mp="2ntetzyft1j4l">
          Pago seguro · Acceso en 5 minutos · Garantía de 7 días
        </p>
      </div>
    </section>;
}